import { Validator } from '@vista-digital/validator';
import { NumberInputType } from '../../form/input/number/types/type';
/**
 * Default configs for the Item Modal component.
 */
export const defaultItemModalConfig = {
    quantityInputType: NumberInputType.Spinner,
    quantityLimit: {
        isUnlimited: true,
        minimum: 0
    }
};
export const itemModalQuantityLimitValidatorSchema = {
    isUnlimited: Validator.boolean(),
    minimum: Validator.number({ min: 0 }),
    maximum: Validator.optional(Validator.number({ min: 1 }))
};
export const itemModalConfigValidatorSchema = {
    quantityInputType: Validator.oneOf(Object.values(NumberInputType)),
    quantityLimit: Validator.object(itemModalQuantityLimitValidatorSchema)
};
